import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';

// Custom Components
import {
  CustomTextInput,
  RadioGroup,
  CheckBoxGroup,
} from '../../Component/FormElements';
import { PrimaryButton, SecondaryButton } from '../../Component/Buttons';
import { AddFieldModal, SuccessModal } from '../../Component/Modal';

const RADIO_OPTIONS = [
  { value: 'mandatory', label: 'Mandatory' },
  { value: 'optional', label: 'Optional' },
  { value: 'nil', label: 'Nil' },
];

const FIELD_LIST = [
  { id: 'sender_field_name', label: '1. Sender field name' },
  { id: 'sender_first_name', label: '2. Sender first name' },
  { id: 'sender_middle_name', label: '3. Sender middle name' },
  { id: 'sender_last_name', label: '4. Sender last name' },
];

const FieldDetails = () => {

  const navigate = useNavigate();
  const [addField, setAddField] = useState(null);
  const [addSuccess, setAddSuccess] = useState(null);

  const [selectedFields, setSelectedFields] = useState(FIELD_LIST.map(f => f.id)); // all checked initially

  const [fieldInputs, setFieldInputs] = useState(() => {
    const initial = {};
    FIELD_LIST.forEach(f => {
      initial[f.id] = {
        fieldNumber: '',
        description: '',
        radio: null,
      };
    });
    return initial;
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  //add-field
  useEffect(() => {
    if (addField !== null) {
      const add_field_modal = new Modal(document.getElementById('add-field-modal'));
      add_field_modal.show();
    }
  }, [addField]);

  //success modal
  useEffect(() => {
    if (addSuccess !== null) {
      const success_modal = new Modal(document.getElementById('success-modal'));
      success_modal.show();
    }
  }, [addSuccess]);

  const handleToggleField = (id, updatedList) => {
    setSelectedFields(updatedList);
  };

  const handleInputChange = (fieldId, key, value) => {
    setFieldInputs(prev => ({
      ...prev,
      [fieldId]: {
        ...prev[fieldId],
        [key]: value,
      },
    }));
  };

  const _handleAddField = () => {
    setAddField(true);
  }

  const _handleCreate = () => {
    setAddSuccess(true);
  }

  return (
    <div className="pt-3 padding-98px-bottom padding-32px-lr">
      <h6 className="pt-3 mb-0 e-primary-font e-font-16 line-height-22px e-font-weight-600 e-text-chinese-black">
        <span
          className="e-text-light-gray-1 text-decoration-hover-underline e-font-weight-400 cursor-pointer"
          onClick={() => navigate("/corridor-config")}
        >
          Corridor config /
        </span>
        <span
          className="e-text-light-gray-1 text-decoration-hover-underline e-font-weight-400 cursor-pointer"
          onClick={() => navigate("/add-corridor")}
        >
          Add corridor /
        </span>
        Field Details
      </h6>

      <h2 className="pt-4 mb-4 mt-2 e-primary-font e-font-weight-600 e-font-20 e-text-chinese-black">
        Field Details
      </h2>

      {FIELD_LIST.map((field) => {
        const isChecked = selectedFields.includes(field.id);
        const inputs = fieldInputs[field.id];

        return (
          <div key={field.id} className="e-border-bottom mb-4">
            <CheckBoxGroup
              data={[field]}
              selectedList={selectedFields}
              checkBoxHandler={(list) => handleToggleField(field.id, list)}
              className="mb-3"
              checkBoxItemClassName="my-1"
            />

            <div className="row mb-2">
              <div className="col-xl-4 col-lg-5 col-md-5">
                <CustomTextInput
                  label="Additional data field number"
                  placeholder="Enter field number"
                  type="text"
                  value={inputs.fieldNumber}
                  handleChange={(val) => handleInputChange(field.id, 'fieldNumber', val)}
                  className="w-100"
                  labelStyle="e-font-weight-400"
                  disabled={!isChecked} // 🔒 Disable when unchecked
                />
              </div>
              <div className="col-xl-4 col-lg-5 col-md-5">
                <CustomTextInput
                  label="Additional data description"
                  placeholder="Enter description"
                  type="text"
                  value={inputs.description}
                  handleChange={(val) => handleInputChange(field.id, 'description', val)}
                  className="w-100"
                  labelStyle="e-font-weight-400"
                  disabled={!isChecked} // 🔒 Disable when unchecked
                />
              </div>
              <div className="col-xl-4 col-lg-6">
                <RadioGroup
                  data={RADIO_OPTIONS}
                  selectedItem={inputs.radio}
                  onSelectItem={(val) => handleInputChange(field.id, 'radio', val)}
                  labelStyle="e-font-weight-400"
                  className="mt-xl-4 mt-2 pt-xl-3"
                  disabled={!isChecked} // 🔒 Disable when unchecked
                />
              </div>
            </div>
          </div>
        );
      })}

      <div className='row'>
        <div className='col-12'>
          <div className='d-flex align-items-center cursor-pointer'>
            <img draggable="false"
              src={require("../../Assets/Images/Home/add-icon.svg").default}
              className='me-1'
              alt='add-field' />
            <span className='e-font-weight-600 e-font-14 e-primary-font e-text-primary-blue' onClick={_handleAddField}>Add fields</span>
          </div>
        </div>
        <div className='offset-lg-3 offset-md-3 col-lg-6 col-md-6 mt-lg-0 mt-md-0 mt-4'>
          <SecondaryButton name="Cancel"
            className="w-25 me-3"
            onPress={() => { }}
          />
          <PrimaryButton name="Create"
            className="w-25 e-bg-primary-blue"
            onPress={_handleCreate}
          />
        </div>
      </div>
      {/* Add field modal */}
      {addField === true &&
        <AddFieldModal
          handleClose={() => setAddField(null)}
        />
      }

      {/* Success modal */}
      {addSuccess === true &&
        <SuccessModal
          handleClose={() => setAddField(null)}
        />
      }
    </div>
  );
};

export default FieldDetails;
